import type {
  FormArray,
  FormControl,
  FormGroup,
  ValidationErrors,
} from '@angular/forms';
import { gte, lte } from '../utilities/comparison.util';

export type ScoreFormGroup = FormGroup<{
  fullMeetExpectationsScore: FormControl<number>;
  minimumTargetLevelScore: FormControl<number>;
  belowExpectationsScore: FormControl<number>;
  poorPerformanceScore: FormControl<number>;
}>;

export class ScoreValidator {
  static scoreRange(array: FormArray<ScoreFormGroup>): ValidationErrors | null {
    if (!array?.value.length) {
      return null;
    }

    const valid = array.value.every(
      (item) =>
        gte(item.fullMeetExpectationsScore, 0) &&
        gte(item.minimumTargetLevelScore, 0) &&
        gte(item.belowExpectationsScore, 0) &&
        gte(item.poorPerformanceScore, 0) &&
        lte(item.fullMeetExpectationsScore, 100) &&
        lte(item.minimumTargetLevelScore, 100) &&
        lte(item.belowExpectationsScore, 100) &&
        lte(item.poorPerformanceScore, 100),
    );

    if (!valid) {
      return { scoreRange: { valid: false } };
    }

    return null;
  }
}
